import React from 'react';
import { ChatButton } from '@web/components';
import { useSession } from '../api';
import { GladlyScript } from '../head';
import { useExperiment, ONBOARDING_FLOW_UI } from '../experiments';

export const GladlyContainer = ({ gladlySettings }) => {
  const { isAppSession } = useSession();

  const { value: onboardingUI } = useExperiment(ONBOARDING_FLOW_UI, 'control');

  if (isAppSession) return <></>;

  return (
    <>
      <GladlyScript />
      <ChatButton onboardingUI={onboardingUI} gladlySettings={gladlySettings} />
    </>
  );
};
